import { PaginationRequest } from '../config/common';

export class PaginationQuotationRequest extends PaginationRequest {
   
}

export interface CreateQuotationRequest {
    customerID?: string,
    branchID?: string,
    vehicleTypeID?: string,
    collectionCompany?: string,
    collectionPostcode?: string,
    deliveryCompany?: string,
    deliveryPostcode?: string,
    price?: number;
    specialInstructions?: string;
}